<template>
  <div class="modal-container">
    <!-- {{orderType}} -->
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="orderType == 1">
            <vxe-radio name="xtabs" label="tab1">托运人订单</vxe-radio>
          </li>
          <li v-if="orderType == 2">
            <vxe-radio name="xtabs" label="tab2">承运人订单</vxe-radio>
          </li>
          <li v-if="orderType == 3">
            <vxe-radio name="xtabs" label="tab3">实际供应方订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box">
        <vxe-input
            v-model="filterName"
            type="search"
            placeholder="请输入订单号"
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px; margin-right: 10px"
        ></vxe-input>
        <vxe-input
            v-model="contractTitle"
            type="search"
            placeholder="请输入订单标题"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
            style="width: 200px; margin-right: 10px"
        ></vxe-input>
        <vxe-input
            v-model="orderName"
            type="search"
            :placeholder="
            orderType === 1
              ? '请输入托运人名称'
              : orderType === 2
              ? '请输入销售方名称'
              : '请输入实际销售方名称'
          "
            @keyup.enter.native="search"
            @search-click="search"
            style="width: 200px"
        ></vxe-input>
      </div>
    </div>
    <div class="add-box clearfix ">

      <vxe-table
          ref="xTable1"
          class="table-style"
          max-height="400"
          border="none"
          align="center"
          :data="tableData"
          auto-resize
          :radio-config="{ highlight: true }"
          show-overflow
          highlight-hover-row
          @cell-click="cellClickEvent"
      >
        <vxe-table-column title="子订单编号" width="120">
          <template slot-scope="{ row }">
            <a
                @click="showBuyerDetail(row)"
                v-if="orderType == 1"
            >{{ row.buyerOrdersNum }}</a
            >
            <a
                @click="showSellerDetail(row)"
                v-if="orderType == 2"
            >{{ row.sellerOrdersNum }}</a
            >
            <a
                @click="showSecSellerDetail(row)"
                v-if="orderType == 3"
            >{{ row.sellerOrdersNum }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            show-overflow
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            show-overflow
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <div style="height: 24px">
              <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
                row.goodsRtnVos[0].goodsName
              }}</span>
              <Icon
                  type="ios-arrow-down"
                  @click.stop="clickEvent3($rowIndex)"
                  v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
              />
              <vxe-pulldown
                  :ref="$rowIndex"
                  transfer
                  placement="bottom"
                  v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
                  style="display: block"
              >
                <template v-slot:dropdown>
                  <div class="my-dropdown3">
                    <vxe-table
                        auto-resize
                        :data="row.goodsRtnVos"
                        stripe
                        show-overflow
                        align="center"
                        max-height="480"
                        :show-header="true"
                    >
                      <vxe-table-column
                          field="goodsName"
                          title="货名"
                          width="135"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="unit"
                          title="单位"
                          width="55"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="counts"
                          title="数量"
                          width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="price"
                          title="单价"
                          width="75"
                      ></vxe-table-column>
                      <vxe-table-column field="isTax" title="含税" width="75">
                        <template slot-scope="{ row }">
                          <span>{{ row.isTax | taxMap }}</span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                          field="carShipNum"
                          title="车船号"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="beginPlace"
                          title="起运地"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                          field="endPlace"
                          title="目的地"
                          width="90"
                      ></vxe-table-column>
                      <vxe-table-column field="beginTime" title="起运日期" width="140">
                        <template slot-scope="{ row }">
                          <span>{{ row.beginTime | timeFormatDate }}</span>
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                  </div>
                </template>
              </vxe-pulldown>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rule" title="规格" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].rule }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="unit" title="单位" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].unit }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].counts
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="price" title="单价" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].price
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="50">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].isTax | taxMap
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="searchCarShipNum" title="车船号" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].searchCarShipNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].beginPlace
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].endPlace
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].beginTime | timeFormatDate
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="createUser"
            title="创建人"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].createTime | timePartRule
            }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-pager
        background
        size="small"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="totalResult"
        @page-change="changePage1"
    ></vxe-pager>
  </div>
</template>

<script>
  import $api from "@/apiProvider";

  export default {
    name: "ChooseOrderTwo",
    props: {
      chainId: {
        type: [String, Number],
        default: 0,
      },

      orderType: {
        type: [String, Number],
        default: 1,
      },
    },
    data() {
      return {
        tableData3: [],
        filterName: null,
        contractTitle: null,
        orderName: null,
        tableData: [],
        selectRow: null,
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
        selectTab: "",
        listQuery: {
          page: 1,
          rows: 10,
          orderBy: 2,
        },
      };
    },
    created() {
      console.log("xxxx" + this.orderType);
      if (this.orderType == 1) {
        this.selectTab = "tab1";
      }
      if (this.orderType == 2) {
        this.selectTab = "tab2";
      }
      if (this.orderType == 3) {
        this.selectTab = "tab3";
      }
    },

    //获取列表
    filters: {
      isTaxRule: function (t) {
        if (t == 0) {
          return "不含税";
        }
        if (t == 1) {
          return "含税";
        }
      },
      // 时间显示part（年月日）
      timePartRule: function (t) {
        if (t) {
          var timeB = new Date(t);
          var y = 1900 + timeB.getYear();
          var m = "0" + (timeB.getMonth() + 1);
          var d = "0" + timeB.getDate();

          return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
          );
        } else {
          return "";
        }
      },
    },
    methods: {
      init() {
        this.filterName = null;
        this.contractTitle = null;
        this.orderName = null;
        (this.currentPage = 1),
          (this.listQuery = {
            page: 1,
            rows: 10,
          }),
          this.getList();
      },
      cancel() {
      },
      search() {
        (this.currentPage = 1),
          (this.listQuery = {
            page: 1,
            rows: 10,
          }),
          this.getList();
      },
      showSecSellerDetail(row) {
        if (!this.isHavePermission('sellerLv2:detail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.$router.push(`/order/secseller/detail/${row.id}`);
        this.$emit("closeRec", false);
      },
      showSellerDetail(row){
        if (!this.isHavePermission('seller:detail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.$router.push(`/order/seller/detail/${row.id}`);
        this.$emit("closeRec", false);
      },
      showBuyerDetail(row) {
        if (!this.isHavePermission('buyer:detail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.$router.push(`/order/sales/detail/${row.id}`);
        this.$emit("closeRec", false);
      },
      async getList() {
        this.listQuery.contractTitle = this.contractTitle;
        if (null != this.chainId && this.chainId > 0) {
          this.listQuery.chainId = this.chainId
        }
        this.loading = true;
        // let data = this.listQuery;
        var urlName = "queryOrdersBuyerRelatedMoneyList";
        let res = {};
        if (this.orderType == 1) {
          if (this.filterName != null && this.filterName != "") {
            this.listQuery.buyerOrdersNum = this.filterName;
          } else {
            this.listQuery.buyerOrdersNum = null;
          }
          if (this.orderName != null && this.orderName != "") {
            this.listQuery.buyerName = this.orderName;
          } else {
            this.listQuery.buyerName = null;
          }
          urlName = "queryOrdersBuyerRelatedMoneyList";
          res = await $api.order.post(urlName, this.listQuery);
        }
        if (this.orderType == 2) {
          urlName = "queryOrdersSellerRelatedMoneyList";
          this.listQuery.isSecondSeller = 0;
          if (this.filterName != null && this.filterName != "") {
            this.listQuery.sellerOrderNum = this.filterName;
          } else {
            this.listQuery.sellerOrderNum = null;
          }
          if (this.orderName != null && this.orderName != "") {
            this.listQuery.sellerName = this.orderName;
          } else {
            this.listQuery.sellerName = null;
          }
          res = await $api.sellerOrder.post(urlName, this.listQuery);
        }
        if (this.orderType == 3) {
          urlName = "queryOrdersSellerRelatedMoneyList";
          this.listQuery.isSecondSeller = 1;
          if (this.filterName != null && this.filterName != "") {
            this.listQuery.sellerOrderNum = this.filterName;
          } else {
            this.listQuery.sellerOrderNum = null;
          }
          if (this.orderName != null && this.orderName != "") {
            this.listQuery.sellerName = this.orderName;
          } else {
            this.listQuery.sellerName = null;
          }
          res = await $api.sellerOrder.post(urlName, this.listQuery);
        }
        if (res.status == 1) {
          this.tableData = res.data.rows;
          // console.log(this.tableData);
          // debugger
          this.totalResult = res.data.total;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
          this.loading = false;
        }
      },
      changePage1(val) {
        this.listQuery.page = val.currentPage;
        this.getList();
        console.log(`当前页: ${val}`);
      },
      radioChangeEvent({row}) {
        this.selectRow = row;
        console.log(this.selectRow);
      },
      commit() {
        //   this.$emit("chooseOrder", this.$refs.xTable1.getRadioRecord());
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      cellClickEvent({row}) {
        this.selectRow = row;
        console.log(this.selectRow);
        this.$emit("chooseOrder", this.selectRow);
        //   console.log("单元格点击事件");
      },
    },
  };
</script>

<style scoped>
  .add-box .vxe-input {
    height: 30px;
    border: 1px solid #f8f8f8;
  }

  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .my-search {
    padding: 10px;
  }

  .my-search .vxe-input {
    height: 34px;
    width: 300px;
  }

  .my-search .vxe-input >>> .vxe-input--suffix {
    display: block !important;
    width: 60px;
    height: 32px;
    top: 1px;
    text-align: center;
    border-left: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    cursor: pointer;
  }

  .my-search .vxe-input >>> .vxe-input--inner {
    padding-right: 72px;
    border: 1px solid #dcdfe6;
  }
</style>